export const actions = {
    SET_TANKS: "SET_TANKS",
    ADD_TANK: "ADD_TANK",
    EDIT_TANK: "EDIT_TANK",
    SET_AREAS: "SET_AREAS",
    ADD_AREA: "ADD_AREA",
    EDIT_AREA: "EDIT_AREA",
    SET_TANKS_OPERATIONS: "SET_TANK_OPERATIONS",
    SET_TANKS_STATE_OPERATIONS: "SET_TANKS_STATE_OPERATIONS"
}

const initialState = {
    areas: [],
    operations: [],
    skipedLoLevelTanks: [],
    tanksStateOperations: [],
    operationsFilter: {
        pagesFilter: { pageCount: 1, currentPage: 1, maxItemsOnPage: 1 },
        modelFilter: {
            tankName: "",
            dateFrom: null,
            dateTo: null
        },
    },
    tanksStateOperationsFilter: {
        pagesFilter: { pageCount: 1, currentPage: 1, maxItemsOnPage: 1 },
        modelFilter: {
            tankName: "",
            dateFrom: null,
            dateTo: null
        },
    },
    filter: {
        pagesFilter: { pageCount: 1, currentPage: 1, maxItemsOnPage: 1 }
    },
    loading: false,
    errors: {},
    forceReload: false
};

export default function reducer(state, action){
    state = state || initialState;

    switch (action.type) {
        case actions.SET_TANKS:
            {
                return {
                    ...state,
                    tanks: action.payload.tanks,
                    filter: action.payload.filter
                };
            }
        case actions.SET_AREAS:
            {
                return {
                    ...state,
                    areas: action.areas
                };
            }
        case actions.ADD_TANK:
            {
                return {
                    ...state,
                    areas: state.areas.map((area, index) => {
                        if (area.id !== action.tank.tankId) {
                            return area;
                        }

                        return { ...area, tanks: [...area.tanks, action.tank] };
                    })
                };
            }
        case actions.ADD_AREA:
            {
                return {
                    ...state,
                    areas: [...state.areas, action.area]
                };
            }
        case actions.EDIT_AREA:
            {
                return {
                    ...state,
                    areas: state.areas.map((item, index) => {
                        if (item.areaId !== action.area.areaId) {
                            // This isn't the item we care about - keep it as-is
                            return item;
                        }

                        // Otherwise, this is the one we want - return an updated value
                        return {
                            ...item,
                            ...action.item
                        };
                    })
                }
            }
        case actions.EDIT_TANK:
            {
                return {
                    ...state,
                    areas: state.areas.map((area, index) => {
                        if (action.tank.areaId !== area.areaId) {
                            return area;
                        }

                        return {
                            ...area,
                            tanks: area.tanks.map((tank) => {
                                if (tank.tankId !== action.tank.tankId) {
                                    return tank;
                                }

                                return {
                                    ...tank,
                                    ...action.tank
                                }
                            })
                        }
                    })
                };
            }
        case actions.SET_TANKS_OPERATIONS:
            {
                return {
                    ...state,
                    operations: action.payload.items,
                    operationsFilter: action.payload.filter
                };
            }
        case actions.SET_TANKS_STATE_OPERATIONS:
            {
                return {
                    ...state,
                    tanksStateOperations: action.payload.items,
                    tanksStateOperationsFilter: action.payload.filter
                };
            }
        default:
            return state;
    }
};

export const setTanks = (tanks, filter) => ({type: actions.SET_TANKS, payload: {tanks, filter}});
export const setTanksOperations = (items, filter) => ({type: actions.SET_TANKS_OPERATIONS, payload: {items, filter}});
export const setTanksStateOperations = (items, filter) => ({type: actions.SET_TANKS_STATE_OPERATIONS, payload: {items, filter}});
export const setAreas = (areas) => ({type: actions.SET_AREAS, areas});
export const addArea = (area) => ({type: actions.ADD_AREA, area});
export const editArea = (area) => ({type: actions.EDIT_AREA, area});
export const addTank = (tank) => ({type: actions.ADD_TANK, tank});
export const editTank = (tank) => ({type: actions.EDIT_TANK, tank});